export function selectContentEvent(contentType: string, contentId: string) {
  return {
    event: 'select_content',
    content_type: contentType,
    content_id: contentId,
  };
}

